module.exports = __webpack_public_path__ + "img/astral-txt_16.da783b15.svg";